
import React from 'react';
import { NikoFacilityOrderPatientTemplateNoteModalTemplate } from 'themes/application/niko-facility-order/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { NikoFacilityOrderPatientTemplateNoteModalStore } from 'application/niko-facility-order/stores';

@setCurrentView((rootStore, componentProps) => new NikoFacilityOrderPatientTemplateNoteModalStore(rootStore, componentProps), 'nikoFacilityOrderPatientTemplateNoteModalStore')
@observer
class NikoFacilityOrderPatientTemplateNoteModal extends React.Component {
    render() {
        return <NikoFacilityOrderPatientTemplateNoteModalTemplate {...this.props} />
    }
}

export default NikoFacilityOrderPatientTemplateNoteModal;
